<input
  [autocomplete]="name"
  class="p-inputtext w-full"
  [class]="cssClass"
  [id]="id"
  [name]="name"
  [(ngModel)]="modelValue"
  [placeholder]="placeholder"
  [type]="type"
  [disabled]="isReadOnly"
  [value]="defaultValue"
  [attr.maxlength]="maxlength === 0 ? null : maxlength"
  [attr.minlength]="minlength === 0 ? null : minlength"
/>
<ng-content></ng-content>
